<wiz-group #filterContainer width="100%" height="100%" verticalAlign="center">
  <span #blockFont
              [style.backgroundColor]="backgroundColor"
              style="border-radius: 26px; border-style: solid; border-width: 1px"
              width="26px"
              height="26px"
            ></span>
  <wiz-checkbox #cbx width="100%" (wizClick)="selectField($event)" style="padding-left: 5px;" ></wiz-checkbox>
</wiz-group>
